module.exports = __webpack_public_path__ + "img/help-process.e581230e.jpg";